module.exports = __webpack_public_path__ + "media/chicken-road-jump_4.f5e4a49c.mp3";